import type { TFunction } from 'i18next';

/**
 * The one render rule for a person's name (TMMAPP-0097 §E 34). tmm-api serves a display name or
 * `null`, never an email (TMMAPI-0140/0141); a missing or blank name reads "A member", so no
 * sharer-facing caption ever renders an empty name.
 */
export function personName(name: string | null | undefined, t: TFunction): string {
  const trimmed = name?.trim() ?? '';
  return trimmed.length > 0 ? trimmed : t('people.aMember');
}
